import { register } from "async-ops";
import { callMvcApi  } from "../../../call-web-api";
import { getDefaultOptions } from "../../../utils/fetch";
export const GET_USER_TASK_LIST_BY_LEVEL = 'GET_USER_TASK_LIST_BY_LEVEL';


export const service = async (data) => {
  const options: object = {
    url:  '/Api/UserTasks/GetTasksList',
    method: "POST",
    contentType: 'application/json',
    body: JSON.stringify(data),
    ...getDefaultOptions(),
  }
  const response = callMvcApi(options);
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(GET_USER_TASK_LIST_BY_LEVEL, service, mock);
